module.exports = __webpack_public_path__ + "media/04.0bdcef5e.mp3";